(() => {
  const initialize = (root = document) => {
    const menu = root.querySelector('.mobile-toggle');
    if (menu && !menu.dataset.bound) {
      menu.dataset.bound = 'true';
      menu.addEventListener('click', () => {
        const open = menu.getAttribute('aria-expanded') === 'true';
        menu.setAttribute('aria-expanded', String(!open));
        document.getElementById('mobile-nav').hidden = open;
      });
      document.querySelectorAll('#mobile-nav a').forEach(link => link.addEventListener('click', () => {
        menu.setAttribute('aria-expanded', 'false');
        document.getElementById('mobile-nav').hidden = true;
      }));
    }
    root.querySelectorAll('[data-catalog]').forEach(catalog => {
      if (catalog.dataset.bound) return;
      catalog.dataset.bound = 'true';
      const input = catalog.querySelector('[data-catalog-search]');
      const cards = [...catalog.querySelectorAll('[data-book-card]')];
      const topics = [...catalog.querySelectorAll('[data-filter]')];
      const genders = [...catalog.querySelectorAll('[data-gender-filter]')];
      const more = catalog.querySelector('[data-catalog-more]');
      const initial = Number(catalog.dataset.initial) || 0;
      const lower = value => (value || '').trim().toLocaleLowerCase('tr');
      // Reklam bağlantıları filtreli açılabilsin: ?cinsiyet=kiz&konu=değerler
      const params = new URLSearchParams(window.location.search);
      const fromURL = (chips, key, param) => {
        const chip = chips.find(c => lower(c.dataset[key]) === lower(params.get(param)));
        return chip ? chip.dataset[key] : 'all';
      };
      let gender = fromURL(genders, 'genderFilter', 'cinsiyet');
      let filter = fromURL(topics, 'filter', 'konu');
      let expanded = false;
      const press = (chips, active) => chips.forEach(chip => {
        chip.classList.toggle('active', chip === active);
        chip.setAttribute('aria-pressed', String(chip === active));
      });
      const apply = () => {
        const query = lower(input.value);
        const fitsGender = card => gender === 'all' || card.dataset.gender === gender;
        // Seçilen cinsiyette kitabı olmayan konu düğmeleri gizlenir (ör. Kız + Spor).
        topics.forEach(chip => {
          chip.hidden = chip.dataset.filter !== 'all' && !cards.some(card => fitsGender(card) && card.dataset.category === chip.dataset.filter);
        });
        if (topics.some(chip => chip.hidden && chip.dataset.filter === filter)) filter = 'all';
        press(topics, topics.find(chip => chip.dataset.filter === filter));
        press(genders, genders.find(chip => chip.dataset.genderFilter === gender));
        // Ana sayfada filtre yokken ilk N kitap görünür; filtre ya da arama varsa uyan kitapların hepsi.
        const limit = !expanded && initial && gender === 'all' && filter === 'all' && !query ? initial : Infinity;
        let count = 0;
        cards.forEach(card => {
          const match = fitsGender(card) && (filter === 'all' || card.dataset.category === filter) && card.dataset.title.toLocaleLowerCase('tr').includes(query);
          if (match) count++;
          card.hidden = !match || count > limit;
        });
        if (more) more.hidden = count <= limit;
        catalog.querySelector('[data-empty-search]').hidden = count > 0;
      };
      const remember = () => {
        const address = new URL(window.location.href);
        if (gender === 'all') address.searchParams.delete('cinsiyet'); else address.searchParams.set('cinsiyet', gender);
        if (filter === 'all') address.searchParams.delete('konu'); else address.searchParams.set('konu', lower(filter));
        window.history.replaceState(window.history.state, '', address);
      };
      topics.forEach(chip => chip.addEventListener('click', () => { filter = chip.dataset.filter; apply(); remember(); }));
      genders.forEach(chip => chip.addEventListener('click', () => { gender = chip.dataset.genderFilter; apply(); remember(); }));
      if (more) more.querySelector('button').addEventListener('click', () => { expanded = true; apply(); });
      input.addEventListener('input', apply);
      apply();
    });
    root.querySelectorAll('[data-product]').forEach(product => {
      if (product.dataset.bound) return;
      product.dataset.bound = 'true';
      const thumbnails = [...product.querySelectorAll('[data-gallery-image]')];
      const main = product.querySelector('.main-gallery-image');
      let current = 0;
      const show = index => {
        if (!thumbnails.length || main.tagName !== 'IMG') return;
        current = index;
        main.removeAttribute('srcset');
        main.src = thumbnails[index].dataset.galleryImage;
        thumbnails.forEach((thumb, i) => {
          thumb.classList.toggle('active', index === i);
          thumb.setAttribute('aria-pressed', String(index === i));
        });
      };
      thumbnails.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
      if (thumbnails.length) show(0);
      product.querySelector('[data-gallery-next]').addEventListener('click', () => show((current + 1) % thumbnails.length));
      const dialog = document.querySelector('[data-book-dialog]');
      product.querySelector('[data-open-preview]').addEventListener('click', () => dialog.showModal());
      dialog.querySelectorAll('[data-close-preview]').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    });
    root.querySelectorAll('.personalization-form').forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      const messages = JSON.parse(document.querySelector('[data-store-messages]').textContent);
      const name = form.querySelector('[data-child-name]');
      const photo = form.querySelector('[data-child-photo]');
      const objectURLs = new Set();
      const summary = () => {
        const value = name.value.trim();
        name.setCustomValidity(value ? '' : messages.nameInvalid);
        form.querySelector('[data-personal-summary]').hidden = !value;
        form.querySelector('[data-summary-name]').textContent = value;
      };
      name.addEventListener('input', summary);
      // Çocuk fotoğrafı (zorunlu) ve isteğe bağlı anne / baba fotoğrafları aynı kontrollerden geçer.
      const bindPhoto = input => {
        const box = input.closest('[data-upload-box]');
        const feedback = box.nextElementSibling;
        const preview = box.querySelector('.photo-preview');
        const empty = box.querySelector('.upload-empty');
        let objectURL = null;
        let selection = 0;
        input.addEventListener('change', async () => {
          const revision = ++selection;
          if (objectURL) { URL.revokeObjectURL(objectURL); objectURLs.delete(objectURL); }
          objectURL = null;
          input.setCustomValidity('');
          feedback.textContent = '';
          feedback.classList.remove('valid');
          preview.hidden = true;
          empty.hidden = false;
          const file = input.files[0];
          if (!file) return;
          const fail = message => { input.setCustomValidity(message); feedback.textContent = message; };
          if (!['image/jpeg','image/png','image/webp'].includes(file.type)) { fail(messages.photoInvalid); return; }
          if (file.size > 10 * 1024 * 1024) { fail(messages.photoLarge); return; }
          input.setCustomValidity(messages.photoLoading);
          const url = URL.createObjectURL(file);
          objectURL = url;
          objectURLs.add(url);
          const check = new Image();
          check.src = url;
          try {
            await check.decode();
            if (revision !== selection) return;
            if (Math.min(check.naturalWidth, check.naturalHeight) < 400) { fail(messages.photoSmall); return; }
            input.setCustomValidity('');
            preview.src = url;
            preview.hidden = false;
            empty.hidden = true;
            feedback.textContent = messages.photoReady + ' · ' + file.name;
            feedback.classList.add('valid');
          } catch { if (revision === selection) fail(messages.photoInvalid); }
        });
      };
      form.querySelectorAll('[data-child-photo], [data-parent-photo]').forEach(bindPhoto);
      form.addEventListener('submit', event => {
        summary();
        if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
        if (document.body.dataset.preview === 'true') {
          event.preventDefault();
          window.dispatchEvent(new CustomEvent('store:preview-add', { detail: { childName: name.value.trim(), photoName: photo.files[0].name, note: form.querySelector('textarea').value } }));
        }
      });
      const variant = form.querySelector('[data-variant-select]');
      if (variant) variant.addEventListener('change', () => {
        const option = variant.selectedOptions[0];
        document.querySelector('[data-variant-price]').textContent = option.dataset.price;
        form.querySelector('[type=submit]').disabled = option.dataset.available !== 'true';
      });
      // Sesli kitap temel üründür; "Basılı kitap da istiyorum" kutusu sepete eklenecek varyantı ve fiyatı değiştirir.
      const formats = form.querySelector('[data-format-choice]');
      if (formats) {
        const toggle = formats.querySelector('[data-print-toggle]');
        const chosen = form.querySelector('[data-format-variant]');
        const update = () => {
          const both = toggle.checked;
          const data = formats.dataset;
          chosen.value = both ? data.bothId : data.audioId;
          const price = document.querySelector('[data-variant-price]');
          if (price) price.textContent = both ? data.bothPrice : data.audioPrice;
          const was = document.querySelector('[data-variant-was]');
          if (was) { was.textContent = both ? data.bothWas : data.audioWas; was.hidden = !was.textContent; }
          const note = document.querySelector('[data-price-note]');
          if (note) note.textContent = both ? data.bothNote : data.audioNote;
          toggle.closest('.format-upgrade').classList.toggle('is-checked', both);
          form.querySelector('[type=submit]').disabled = (both ? data.bothAvailable : data.audioAvailable) !== 'true';
          const address = new URL(window.location.href);
          address.searchParams.set('variant', chosen.value);
          window.history.replaceState(window.history.state, '', address);
        };
        toggle.addEventListener('change', update);
        update();
      }
      window.addEventListener('pagehide', () => objectURLs.forEach(url => URL.revokeObjectURL(url)));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
